import { NavLink } from "react-router-dom";
import { useOrg } from "../lib/org";
import {useBankReviewCapability} from '../pages/BankReview';

interface NavItem {
  to: string;
  label: string;
  icon: string;
}
interface NavGroup {
  title?: string;
  items: NavItem[];
}

const GROUPS: NavGroup[] = [
  { items: [{ to: "/", label: "Dashboard", icon: "▦" }] },
  {
    title: "Sales",
    items: [
      { to: "/customers", label: "Customers", icon: "☺" },
      { to: "/invoices", label: "Invoices", icon: "🧾" },
      { to: "/payments", label: "Payments", icon: "💵" },
    ],
  },
  {
    title: "Expenses",
    items: [
      { to: "/vendors", label: "Vendors", icon: "🏷" },
      { to: "/bills", label: "Bills", icon: "📑" },
      { to: "/expenses", label: "Expenses", icon: "💳" },
    ],
  },
  {
    title: "Accounting",
    items: [
      { to: "/accounts", label: "Chart of Accounts", icon: "📚" },
      { to: "/items", label: "Products & Services", icon: "📦" },
      { to: "/journal", label: "Journal Entries", icon: "✎" },
    ],
  },
  {
    title: "Insights",
    items: [
      { to: "/reports", label: "Reports", icon: "📊" },
      { to: "/settings", label: "Settings", icon: "⚙" },
    ],
  },
];

export function Sidebar() {
  const { user } = useOrg();
  const review=useBankReviewCapability();
  const groups: NavGroup[] = user?.isSuperAdmin
    ? [
        ...GROUPS,
        {
          title: "Administration",
          items: [{ to: "/admin/users", label: "Users", icon: "👤" },{to:'/corrections',label:'Correct transactions',icon:'↶'}],
        },
      ]
    : GROUPS;

  return (
    <aside className="fixed inset-y-0 left-0 z-30 flex w-60 flex-col border-r border-gray-200 bg-white">
      <div className="flex h-16 items-center gap-2 border-b border-gray-200 px-5">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-500 font-bold text-white">
          GL
        </span>
        <span className="text-lg font-semibold tracking-tight text-gray-900">
          General Ledger
        </span>
      </div>
      <nav className="flex-1 overflow-y-auto px-3 py-4">
        {groups.map((group, i) => (
          <div key={i} className="mb-5">
            {group.title && (
              <p className="mb-1 px-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                {group.title}
              </p>
            )}
            {group.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `mb-0.5 flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition ${
                    isActive
                      ? "bg-brand-50 text-brand-700"
                      : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                  }`
                }
              >
                <span className="w-4 text-center text-base leading-none">
                  {item.icon}
                </span>
                {item.label}
              </NavLink>
            ))}
            {group.title==='Accounting'&&review.data?.enabled&&<NavLink to="/bank-review" className={({isActive})=>`mb-0.5 flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium ${isActive?'bg-brand-50 text-brand-700':'text-gray-600 hover:bg-gray-100'}`}><span>✓</span>Review bank transactions</NavLink>}
          </div>
        ))}
      </nav>
    </aside>
  );
}
